import { useFetchUserByIdGerente } from './useFetchUserByIdGerente'
import { useFetchUserByTenant } from './useFetchUserByTenant'

import { TypeCargoUser } from '@/lib/enums'
import { useCurrentUser } from '@/features/auth/state/auth'

//TODO: Create a UserAPI and a User DTO interface to handle the user data
// interface User {
//   id?: string
//   cpf?: string
//   name?: string
//   email?: string
//   typeUser?: string
//   typeCargo?: string
//   id_tenant?: string
//   nome?: string
//   cnpjcpf?: string
//   typeCategoria?: string
//   status?: string
// }

export function useUserData() {
  const user = useCurrentUser()
  const isGerente = user?.typeCargo === TypeCargoUser.GERENTE
  const { data: usersGerente = [], isLoading: gerenteLoading } = useFetchUserByIdGerente()
  const { data: usersTenant = [], isLoading: tenantLoading } = useFetchUserByTenant()
  let transforedUsers = []
  let data = []

  if ((user?.typeCargo === 'CEO' || user?.typeCargo === 'GERENTE') && user?.typeUser === 'USUARIO') {
    data = isGerente ? usersGerente : usersTenant
    transforedUsers = data.map((user: any) => ({
      ...user,
      status: user.isAccepted === true ? 'Ativo' : 'Pendente',
      cnpjcpf: user.cpf || user.cnpj
    }))
  }

  return {
    users: transforedUsers,
    isGerente,
    currentUserRole: user?.typeCargo,
    isLoading: gerenteLoading || tenantLoading
  }
}
